/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PoolTransactionHolderBonus
 */
export interface PoolTransactionHolderBonus {
  /**
   *
   * @type {number}
   * @memberof PoolTransactionHolderBonus
   */
  durationInSeconds?: number
  /**
   *
   * @type {number}
   * @memberof PoolTransactionHolderBonus
   */
  durationDeltaInSeconds?: number
}

export function PoolTransactionHolderBonusFromJSON(json: any): PoolTransactionHolderBonus {
  return PoolTransactionHolderBonusFromJSONTyped(json, false)
}

export function PoolTransactionHolderBonusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PoolTransactionHolderBonus {
  if (json === undefined || json === null) {
    return json
  }
  return {
    durationInSeconds: !exists(json, 'durationInSeconds') ? undefined : json['durationInSeconds'],
    durationDeltaInSeconds: !exists(json, 'durationDeltaInSeconds') ? undefined : json['durationDeltaInSeconds'],
  }
}

export function PoolTransactionHolderBonusToJSON(value?: PoolTransactionHolderBonus | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    durationInSeconds: value.durationInSeconds,
    durationDeltaInSeconds: value.durationDeltaInSeconds,
  }
}
